import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getTreeData: host + 'taskMenu/getTaskMenuList',//目录树形结构
    getBreadCrumbData: host +'taskMenu/getTaskMenuNavigation', //面包屑数据
    getResourceData: host + 'taskMenuResource/getTaskMenuResourceList', //资源列表
    pictureConvertParams: host + 'interview/saveInterviewPicture', //将图片与采访任务绑定
    videoConvertParams: host + 'interview/saveInterviewVideo', // 将视频与采访任务绑定
    audioConvertParams: host + 'interview/saveInterviewAudio', // 将音频与采访任务绑定
    otherFileConvertParams: host + 'interview/saveInterviewAttachment', //将附件与采访任务绑定
    delResource: host + 'taskMenuResource/delTaskMenuResource', //资源解绑
    decompressionZip: host + 'taskMenuResource/decompressionZip', //解压压缩包
    getTaskMenuResourceStatus: host + 'taskMenuResource/getTaskMenuResourceStatus', //判断是否解压完成
    updateTaskMenuResourceStatus: host + 'taskMenuResource/updateTaskMenuResourceStatus', //在解压过程中终止
};

//目录树形结构
export const getTreeData = (body, callBack) => {
    request({url:Apis.getTreeData, body, callBack});
}

//面包屑数据
export  const getBreadCrumbData = (body, callBack) => {
    request({url:Apis.getBreadCrumbData, body, callBack});
}

//资源列表
export const getResourceData = (body, callBack) => {
    request({url:Apis.getResourceData, body, callBack});
}

/**将图片与采访任务绑定*/
export const pictureConvertParams = (body, callBack) => {
    request({url:Apis.pictureConvertParams, body, method:"post", callBack});
};

/**将视频与采访任务绑定*/
export const videoConvertParams = (body, callBack) => {
    request({url:Apis.videoConvertParams, body, method:"post", callBack});
}

/**将音频与采访任务绑定*/
export const audioConvertParams = (body, callBack) => {
    request({url:Apis.audioConvertParams, body, method:"post", callBack});
}

/**将美工附件与采访任务绑定*/
export const otherFileConvertParams = (body, callBack) => {
    request({url:Apis.otherFileConvertParams, body, method:"post", callBack});
}

//将资源与任务解绑
export const delResource = (body, callBack) => {
    request({url:Apis.delResource, body, method:"post", callBack});
};

//解压压缩包
export const decompressionZip = (body, callBack) => {
    request({url:Apis.decompressionZip, body, method:"post", callBack});
}

//查询解压是否完成
export const getTaskMenuResourceStatus = (body, callBack) => {
    request({url:Apis.getTaskMenuResourceStatus, body, method:"post", callBack});
}

//在解压过程中终止
export const updateTaskMenuResourceStatus = (body, callBack) => {
    request({url:Apis.updateTaskMenuResourceStatus, body, method:"post", callBack});
}